<template>
    <div class="container position-absolute top-50 start-50 translate-middle">
        <h1>Error 404</h1>
        <h3>No existe la dirección</h3>
        <router-link to="/">Volver a la página de inicio</router-link>
    </div>
</template>